import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import logo_light from './../../public/images/LogoSKT/SKT-LOGO-LIGHT.png'
import './Sidebar.css'
import Dashboard from './Dashboard';
import Createorder from './Createorder';
import Vieworders from './OrderDetails';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import { CgProfile } from "react-icons/cg";
import { MdOutlineSettings } from "react-icons/md";
import { FaRegBell } from "react-icons/fa";
import AdminProfile from './AdminProfile';
import Customer from './Customer';
import JobPost from './JobPost';
import MyPost from './MyPost';
import Applicants from './Applicants';
import { Outlet, useNavigate } from 'react-router-dom';
// import Getintouch from './Getintouch';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function Sidebar() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [text_show, setTextshow] = React.useState('d-none');
  const [selectedComponent, setSelectedComponent] = React.useState('dashboard');
  const navigate = useNavigate()
  React.useEffect(() => {
    if (open === true) {
      setTextshow('d-block');
    } else {
      setTextshow('d-none');
    }
  }, [open]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


const handleLogout = () => {
  localStorage.removeItem("isAdmin");
  navigate("/login");
};
  
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            <img src={logo_light} alt="Skill Technologies" height={70} width={150} />
          </Typography>
          <div className="d-flex ms-auto">
            <div className="d-flex ms-auto">
              <PopupState variant="popover" popupId="demo-popup-popover">
                {(popupState) => (
                  <div>
                    <Button variant="contained" {...bindTrigger(popupState)}>
                      <FaRegBell style={{ fontSize: '25px', marginTop: '6px' }} />
                    </Button>
                     <Button onClick={handleLogout} className="btn btn-info text-white mt-2">
                      Log Out
                    </Button>
                    <Popover
                      {...bindPopover(popupState)}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      className='mt-3'
                    >
                      <Typography sx={{ p: 1, pl: 5, pr: 5 }}>
                        <div className="d-flex">
                          <FaRegBell className='me-1' style={{ fontSize: '20px', marginTop: '2px' }} />
                          <a>notification 1</a>
                        </div>
                      </Typography>
                      <Typography sx={{ p: 1, pl: 5, pr: 5 }}>
                        <div className="d-flex">
                          <FaRegBell className='me-1' style={{ fontSize: '20px', marginTop: '2px' }} />
                          <a>notification 2</a>
                        </div>
                      </Typography>
                    </Popover>
                  </div>
                )}
              </PopupState>
            </div>
            <div className="d-flex ms-auto">
              <PopupState variant="popover" popupId="demo-popup-popover">
                {(popupState) => (
                  <div>
                    <Button variant="contained" {...bindTrigger(popupState)}>
                      <CgProfile style={{ fontSize: '40px' }} />
                    </Button>
                    <Popover
                      {...bindPopover(popupState)}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      className='mt-2'
                    >
                      <Typography sx={{ p: 1, pl: 5, pr: 5 }}>
                        <div className="d-flex" onClick={() => navigate('/admin/profile')}>
                          <CgProfile className='me-1 pointer' style={{ fontSize: '30px' }} />
                          <a className='lead pointer'>Profile</a>
                        </div>
                      </Typography>
                      <Typography sx={{ p: 1, pl: 5, pr: 5 }}>
                        <div className="d-flex" onClick={() => navigate('/admin/settings')}>
                          <MdOutlineSettings className='me-1 pointer' style={{ fontSize: '30px' }} />
                          <a className='lead pointer'>Settings</a>
                        </div>
                      </Typography>
                    </Popover>
                  </div>
                )}
              </PopupState>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ul class="custom-list">
            <li className='ms-2' onClick={() => navigate('/admin/dashboard')}>
              <div class="icon pointer">
                <img src="https://cdn.iconscout.com/icon/free/png-256/free-dashboard-1739866-1481441.png" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                Dashboard
              </div>
            </li>
            <li className='ms-2' onClick={() => navigate('/admin/customer')}>
              <div class="icon pointer">
                <img src="https://cdn.iconscout.com/icon/free/png-256/free-applicant-33-1108409.png" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                Customers
              </div>
            </li>
            <li className='ms-2' onClick={() => navigate('/admin/createorder')}>
              <div class="icon pointer">
                <img src="https://static.thenounproject.com/png/2931752-200.png" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                Create Order
              </div>
            </li>
            <li className='ms-2' onClick={() => navigate('/admin/vieworder')}>
              <div class="icon pointer" >
                <img src="https://www.shutterstock.com/image-vector/order-status-tracking-concept-line-260nw-783301813.jpg" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                Order Details
              </div>
            </li>
            <li className='ms-2' onClick={() => navigate('/admin/postjob')}>
              <div class="icon pointer" >
                <img src="https://static.thenounproject.com/png/1551321-200.png" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                Post Job
              </div>
            </li>
            <li className='ms-2'  onClick={() => navigate('/admin/mypost')}>
              <div class="icon pointer" >
                <img src="data:image/png;base64,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" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                My Post
              </div>
            </li>
            <li className='ms-2'  onClick={() => navigate('/admin/applicants')} >
              <div class="icon pointer" >
                <img src="https://cdn.iconscout.com/icon/free/png-256/free-applicant-33-1108409.png" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                Applicants
              </div>
            </li>
            {/* <li className='ms-2' onClick={handleGetintouch}>
              <div class="icon pointer" >
                <img src="https://cdn.iconscout.com/icon/free/png-256/free-applicant-33-1108409.png" alt="" height={25} width={25} />
              </div>
              <div class={`${text_show} pointer`}>
                Get In Touch
              </div>
            </li> */}
          </ul>

        </List>
        <Divider />
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <section>
          <Outlet/>
        </section>
      </Box>
    </Box>
  );
}